(function() { window.GUID_d7ae98d2_a42f_418b_b483_99c9c4181a4f = { getGuid: function() { return "d7ae98d2-a42f-418b-b483-99c9c4181a4f"; } }; })();
var CS;
(function (CS) {
    class Body {
        static RegisterBodyScripts() {
            CS.DOM.$body.offon("click.body", ".body-element,.trig-on-click,a:not(.external,.ui-state-disabled)", function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                const $element = $(e.currentTarget);
                const isEventDropdownItem = $element.closest(".event-dropdown").length > 0;
                if (isEventDropdownItem) {
                    const updateLastSearchUrl = $element.attr("data-updatelastsearchurl");
                    if (updateLastSearchUrl != null &&
                        updateLastSearchUrl.trim() != "") {
                        CS.Ajax.Post(updateLastSearchUrl, {});
                    }
                }
                if ($element.hasClass("gal-item")) {
                    CS.Controls.Gallery.GalItemClick($element, e);
                }
                else if ($element.hasClass("is-premium-locked")) {
                    let premium = $element.hasClass("premium");
                    //if (premium && CS.CommonData.Current.IsNativeApp) {
                    //    CS.Ads.TryPremiumOrSubscribe();
                    //} else {
                    let url = CS.Url.CSUrl("PremiumLanding");
                    if (premium) {
                        const containsOrigin = url.indexOf(window.location.origin) !== -1;
                        url = (containsOrigin ? "" : window.location.origin) + url;
                        const urlObject = new URL(url);
                        const queryString = urlObject.search;
                        const urlParams = new URLSearchParams(queryString);
                        urlParams.set("premium", premium.toString());
                        url = urlObject.origin + urlObject.pathname + "?" + urlParams;
                    }
                    CS.Nav.Go(url);
                    //}
                    //if (CS.CommonData.Current.IsNativeApp) {
                    //    if (confirm('Do you want to watch an Ad to access that Premium feature?')) {
                    //        ShowRewardAd("true");
                    //    } else {
                    //        CS.Nav.Go(Url.CSUrl("subscription"), { premium });
                    //    }
                    //} else {
                    //CS.Nav.Go(Url.CSUrl("subscription"), { premium });
                    //}
                }
                else if ($element[0].tagName == "A" ||
                    $element.hasClass("divnav")) {
                    const hasAnalyticsData = $element.attr("data-ga-data-key");
                    if (hasAnalyticsData) {
                        const { category, action, label, value, isValid } = CS.Helper.GoogleAnalyticsHelper.getDataFromElement($element);
                        if (isValid) {
                            CS.Analytics.Event(category, action, label, value);
                        }
                    }
                    let href = $(this).attr("href");
                    if (href == "#") {
                        return;
                    }
                    //  console.log($element.attr('target'));
                    if ($element.attr("target") == "_blank" &&
                        CS.CommonData.Current.IsNativeApp) {
                        console.log("external link");
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        CS.NativeApp.NA_OpenExternalLink(href);
                    }
                    if ($element.hasClass("trig-on-click")) {
                        $element.trigger($element.data("eventtotrigonitemclick"));
                        return;
                    }
                    if ($element.hasClass("navpost")) {
                        CS.Nav.Go(href, null, CS.Nav.Source.Post, $element.hasClass("replace-url"));
                    }
                    else if ($element.hasClass("ajaxpost")) {
                        CS.Ajax.Post(href, null);
                    }
                    else if ($element.hasClass("replace-url")) {
                        CS.Nav.Go(href, null, CS.Nav.Source.Standard, true);
                    }
                    else {
                        CS.Nav.Go(href);
                    }
                }
            });
            if (CS.CommonData.Current && CS.CommonData.Current.IsNativeApp) {
                CS.DOM.$body.offon("click.bodyexternal", "a.external:not(.ui-state-disabled)", function (e) {
                    let href = $(this).attr("href");
                    if (href.indexOf("compusportexternal") != -1) {
                        return;
                    }
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    CS.NativeApp.NA_OpenExternalLink(href);
                });
            }
        }
    }
    CS.Body = Body;
})(CS || (CS = {}));
//window.addEventListener("load", () => {
//    new CS.Body();
//});

//# sourceMappingURL=cs-body.js.map
